export default "__VITE_ASSET__cb1298af__"